function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "1lcnlc5aja"
}, React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
  filter: "url(#1lcnlc5aja)",
  transform: "translate(-86 -456) translate(0 -237) translate(0 420) translate(24 188) translate(0 73) translate(62 12)"
}, React.createElement("g", null, React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M.755.692c.309-.04.622.029.886.194l9 5.116-2.278 2.306L.755.692zm-.693.693c-.043.15-.064.307-.062.463v14.304c-.002.156.019.313.062.463L7.678 9 .062 1.385zM8.37 9.692L.755 17.308c.309.043.623-.025.886-.194l9-5.116L8.37 9.692zm5.898-1.62l-2.727-1.55L9.048 9l2.486 2.485 2.728-1.55c.9-.513.9-1.357 0-1.87l.006.007z",
  transform: "translate(5 3)"
})))))))));

var SvgGooglePlayIcon = function SvgGooglePlayIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGooglePlayIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-play_icon.8bdafa70.svg";
export { ForwardRef as ReactComponent };